import { Clickable } from '@carvana/merch-components';
import cx from 'classnames';
import { useContext } from 'react';
import { useIsMobile } from '~/context/common/DeviceContext';
import GlobalContext from '~/context/giveaway/GlobalContext';
import ModalContext from '~/context/giveaway/ModalContext';
import useShareLink from '~/hooks/common/useShareLink';
import useSpinnerSize from '~/hooks/giveaway/useSpinnerSize';
import GiveawayIcon from '~/icons/GiveawayIcon';
import ShareIcon from '~/icons/Share';
import { withErrorBoundary } from '~/utilities/ErrorBoundary';
import styles from './Spinner.module.css';
import SpinnerLoader from './SpinnerLoader';
import {
  BottomSection,
  Container,
  H4,
  LeftSection,
  RightSection,
  Section,
  ShareContainer,
  SuperDialedContainer,
  SuperDialedWrapper,
  TopSection
} from './SpinnerSection.styles';
import { StaticImage } from './StaticImage';
import { shareData } from '../constants';
import { DarkCtaButton } from '../CtaButton';

type OwnProps = {
  image: string;
};

const SpinnerSection = ({ image }: OwnProps) => {
  const {
    giveawayIsLive,
    isSpinnerImmersive,
    isSpinnerReady,
    openKeyFeatures
  } = useContext(GlobalContext);
  const { setGiveawayModalOpen } = useContext(ModalContext);
  const isMobile = useIsMobile();
  const shareLink = useShareLink(shareData);
  const spinnerSize = useSpinnerSize();

  return (
    <Section className={!isSpinnerImmersive ? 'z-1' : undefined}>
      <hr className="border-t border-grey-2" />
      <TopSection>
        <LeftSection>
          <H4>jaxson riddle&apos;s rig</H4>
          <Container>
            <GiveawayIcon />
            <span className="pl-8 font-bold text-grey-5">
              giveaway showcase
            </span>
          </Container>
          <SuperDialedContainer>
            <SuperDialedWrapper>
              <span>Super Dialed</span>
              <span className="hidden m:block">•</span>
              <span>5,000&apos; + elevation</span>
            </SuperDialedWrapper>
          </SuperDialedContainer>
        </LeftSection>
        {!isMobile && (
          <RightSection>
            <Clickable
              element={ShareContainer}
              onClick={shareLink}
              data-analytics-id="giveaway-share"
              data-qa="giveaway-share"
              title="Share"
            >
              <ShareIcon className="h-24 w-24" fill="#00aed9" />
            </Clickable>
            <DarkCtaButton
              className="h-56 w-[196px] l:w-[250px]"
              data-analytics-id="Spinner - Open Giveaway Modal"
              data-qa="giveaway-cta-button"
              disabled={!giveawayIsLive}
              onClick={() => {
                setGiveawayModalOpen(true);
              }}
              type="button"
            >
              {giveawayIsLive ? 'enter to win' : 'giveaway ended'}
            </DarkCtaButton>
          </RightSection>
        )}
      </TopSection>
      <BottomSection style={{ ...spinnerSize }}>
        <StaticImage image={image} isVisible={!isSpinnerReady.isLoaded} />
        <div
          className={cx(
            styles.giveawaySpinner,
            'col-span-1 row-span-1 flex flex-col'
          )}
        >
          <SpinnerLoader containerSize={spinnerSize} />
        </div>
      </BottomSection>
      {isMobile && (
        <DarkCtaButton
          className="h-40 w-[200px] rounded-full capitalize"
          data-analytics-id="giveaway-features-button"
          type="button"
          onClick={openKeyFeatures}
        >
          key features
        </DarkCtaButton>
      )}
    </Section>
  );
};

export default withErrorBoundary(SpinnerSection);
